var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "editableContainer",
      staticClass: "editable-wrapper",
      class: { "editable-area": _vm.editable, animate: _vm.animate },
      on: { click: _vm.handleClick }
    },
    [
      _c("transition", { attrs: { name: "editor-pop", appear: "" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isEditing && !_vm.applyClick,
                expression: "isEditing && !applyClick"
              }
            ],
            staticClass: "editor-container"
          },
          [
            _c("div", { staticClass: "editing-label" }, [
              _vm._v(_vm._s(_vm.editLabel))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inline-editor-wrapper", style: _vm.editorStyles },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedValue,
                      expression: "editedValue"
                    }
                  ],
                  ref: "editInput",
                  staticClass: "inline-editor__input",
                  attrs: { maxlength: _vm.maxlength },
                  domProps: { value: _vm.editedValue },
                  on: {
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        )
                          return null
                        return _vm.cancelEdit.apply(null, arguments)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleEnter.apply(null, arguments)
                      }
                    ],
                    blur: _vm.saveEdit,
                    click: function($event) {
                      $event.stopPropagation()
                    },
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.editedValue = $event.target.value
                    }
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.isEditing
        ? _c("div", {
            ref: "modalBackdrop",
            staticClass: "popup-backdrop",
            on: { click: _vm.saveEdit }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }